import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SvgIcon,
  Checkbox,
  Divider,
  styled,
  Link,
  IconButton,
  useTheme,
} from "@mui/material";
import axiosInstance from "../../../axios/axios";
import CloseIcon from "@mui/icons-material/Close";
import dayjs, { Dayjs } from "dayjs";
import { useEncryptService, useUTCDate } from "../../../shared/hooks";
import CredentialForm from "./CredentialForm";
import ScheduleForm from "./ScheduleForm";
import SSHService from "../../../shared/hooks/SSHService";
import IOSSwitch from "../../../components/IOSSwitch";
import Upload_img from "../../../assets/baseVersion/Upload_img.svg";
import { toast } from "react-toastify";
// import { resetUserTypeFlags, setIsBothCloudAndPremAssetUser, setIsNewUserTrue, setIsOnlyCloudUser, setIsOnlyPremAssetUser } from "../../../modules/authentication/login/Login_Details_slice";
// import { END_POINTS } from "../../../shared/endpoints";
// import { useDispatch } from "react-redux";

// Regular expression for IP address validation
const ipRegex =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,6}(\/[^\s]*)?$/;
interface FrequencyOptions {
  frequency?: any;
  timeZone?: any;
  date?: any;
  timeOptions?: any;
  Days?: any;
  timeNowOptions?: any;
}
interface Props {
  onDirty: (dirty: boolean) => void; // Tracks dirty state for unsaved changes
  onSubmit?: () => void; // Optional callback on submit
  vendorList: any[]; // ✅ Accepts vendor list pro
  scheduleOptions?: FrequencyOptions;
  vendorSelected?: any; // Make selectedVendor optional
  component?: any;
  onCallback?: (data: any, isSwitchOn: boolean, files: File[]) => void;
  isLoading?: boolean; // Add isLoading prop
}
interface Category {
  id: string;
  name: string;
}

const ReusableSSHAPI: React.FC<Props> = ({
  onDirty,
  vendorList,
  scheduleOptions,
  vendorSelected,
  component,
  onCallback,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [processingButton, setProcessingButton] = useState<'scan' | 'schedule' | null>(null);
  const { doEncryptLogin } = useEncryptService();
  const { utcObj } = useUTCDate();
  const [scanName, setScanName] = useState<string>(""); // scanName is now optional
  const [credName, setCredName] = useState<string>("");
  const [customPort, setCustomPort] = useState<boolean>(false); // State for customPort
  const [customPortNumber, setCustomPortNumber] = useState<string>(""); // State for custom port number
  const [assetIp, setAssetIp] = useState<string>(""); // State for Asset IP/URL
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [error, setError] = useState<string>(""); // Error for scanName
  const [customPortError, setCustomPortError] = useState<string>(""); // Error for custom port number
  const [assetIpError, setAssetIpError] = useState<string>(""); // Error for Asset IP validation
  const [selectedVendor, setSelectedVendor] = useState<any | null>(
    vendorSelected?.id || null
  );
  const [vendorError, setVendorError] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [categories, setCategories] = useState<Category[]>(
    vendorSelected != null ? vendorSelected.categories : []
  );
  const [vendorname, setVendorName] = useState<string>(vendorSelected != null ? vendorSelected.name : "");
  const [isCategoryDirty, setIsCategoryDirty] = useState<boolean>(false);
  const [categoryError, setCategoryError] = useState<string>(""); // Error for category selection
  const [credentialsList, setCredentialsList] = useState([]);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const banner =
    component === "api"
      ? "Define your API details and start your scan"
      : component === "winRM"
        ? "Enter your Windows credentials to enable WinRM access."
        : "Fetch configuration from asset to scan";
  type PasswordType = {
    id: string;
    code: string;
    name: string;
  };

  type CredentialType = {
    id: string;
    code: string;
    name: string;
    password_type: PasswordType[];
  };
  const [credentialsTypes, setCredentialsTypes] = useState<CredentialType[]>(
    []
  );
  const [selectedCredential, setSelectedCredential] = useState<any | null>(
    null
  );
  const [username, setUsername] = useState("");
  const [passwordType, setPasswordType] = useState("none");
  const [credential_type_id, setCredentialTypeId] = useState<any | null>(null);
  const [execPassword, setExecPassword] = useState(false);
  const [autoAssign, setAutoAssign] = useState(false);
  const [password, setPassword] = useState("");
  const [execPasswordText, setExecPasswordText] = useState("");
  const [isScheduled, setIsScheduled] = useState<boolean>(false);
  const [saveCredential, setSaveCredential] = useState<boolean>(false);
  const [selectedFrequency, setSelectedFrequency] = useState<any | null>(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [date, setDate] = useState<string>("");
  const [selectedDay, setSelectedDay] = useState<any | null>(null);
  const [selectedTime, setSelectedTime] = useState<any | null>(null);
  const [selectedHour, setSelectedHour] = useState<string>("");
  const [selectedMinute, setSelectedMinute] = useState<string>("");
  const [selectedAmPm, setSelectedAmPm] = useState<string>("");
  // New states for hourly frequency
  const [hourlyInterval, setHourlyInterval] = useState<string>("");
  const [hourlyMinute, setHourlyMinute] = useState<string>("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [usernameError, setUsernameError] = useState("");
  const [credNameError, setCredNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordTypeError, setPasswordTypeError] = useState("");
  const [isScheduleScanDisabled, setIsScheduleScanDisabled] =
    useState<boolean>(true);
  const [files, setFiles] = useState<File[]>([]); // State to store uploaded files
  const [isLoading, setIsLoading] = useState(false);
  const [privateKeyFile, setPrivateKeyFile] = useState<File | null>(null);
  const [privateKeyValidationMessage, setPrivateKeyValidationMessage] = useState<string>("");

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsSwitchOn(event.target.checked);
    // Removed erroneous assignment to 'boolean'
    //trackDirtiness(event.target)
  };
  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const selectedFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]); // Add selected files to the state
    }
  };

  // Handle file deletion
  const deleteFile = (index: number) => {
    setFiles(files.filter((_, i) => i !== index)); // Remove the file from the state
  };

  const handlePrivateKeyUpload = useCallback(
    (file: File | null, content?: string) => {
      setPrivateKeyFile(file);
      if (passwordType === "private_key") {
        if (file && typeof content === "string") {
          setPassword(content);
          setPrivateKeyValidationMessage("");
          setPasswordError("");
        } else {
          setPassword("");
          if (!file) {
            setPrivateKeyValidationMessage("Private key file is required");
          }
        }
      } else if (!file) {
        setPrivateKeyValidationMessage("");
      }
    },
    [passwordType]
  );

  // Track form dirty state for all fields
  const trackDirtiness = (isSwitch: any = false) => {
    const initialValues = {
      scanName: "",
      customPort: false,
      customPortNumber: "",
      assetIp: "",
      selectedVendor: vendorSelected != null ? vendorSelected.id : null,
      selectedCategory: null,
      selectedCredential: null,
    };

    const currentState = {
      scanName,
      customPort,
      customPortNumber,
      assetIp,
      selectedVendor,
      selectedCategory,
      selectedCredential,
    };

    // Check if the 'isSwitchOn' is true or false
    if (isSwitchOn) {
      // If switch is on, check dirtiness for files
      const initialFileCount = 0; // assuming initial files are empty, update if necessary
      const currentFileCount = files.length;

      // Check if the files array is different from the initial value (empty array)
      const fileDirtyState = currentFileCount > initialFileCount;

      const fieldsDirtyState = Object.keys(initialValues).some(
        (key) =>
          key === "scanName" || key === "selectedCredential" ? currentState[key as keyof typeof currentState] !== initialValues[key as keyof typeof initialValues] : false
      );

      // Combine file dirty state with fields dirty state
      const dirtyState = fileDirtyState || fieldsDirtyState;

      setIsDirty(dirtyState);
      onDirty(dirtyState);
    } else {
      // If switch is off, check dirtiness for other fields
      let dirtyState = Object.keys(initialValues).some(
        (key) =>
          currentState[key as keyof typeof currentState] !==
          initialValues[key as keyof typeof initialValues]
      );

      setIsDirty(dirtyState);
      onDirty(dirtyState);
    }
  };


  const resetCredentialFields = () => {
    setUsername("");
    setPasswordType("none");
    setPassword("");
    setExecPasswordText("");
    setExecPassword(false);
    setAutoAssign(false);
    setPrivateKeyFile(null);
    setPrivateKeyValidationMessage("");
  };


  const fetchFileData = async () => {
    await SSHService.fetchFileData();
  }

  useEffect(() => {
    // Function to fetch credentials
    const fetchCredentials = async () => {
      try {
        // Map component type to credential type code
        const credentialType = component === "winRM" ? "windows" : component;
        const response = await axiosInstance.get(
          `securityscan/asset-credentials?type=${credentialType}`
        );
        const credList = response.data?.data?.cred_list || [];
        setCredentialsList(credList); // Set the fetched credentials list
      } catch (error) {
        toast.error("Error fetching credentials");
      }
    };
    const fetchCredentialstypes = async () => {
      try {
        const response = await axiosInstance.get(
          `securityscan/credential-types`
        );
        const credList = response.data?.data || [];
        setCredentialsTypes(credList); // Set the fetched credentials list
      } catch (error) {
        toast.error("Error fetching credentials Types");
      }
    };

    const fetchData = async () => {
      try {
        console.log("Starting to fetch data...");
        await Promise.all([fetchCredentials(), fetchCredentialstypes()]);
        console.log("Data fetching completed.");
      } catch (error) {
        toast.error("Error during data fetching");
      }
    };

    fetchData();
    trackDirtiness(); // Track dirtiness on initial render
    const is = !isFormValid();
    setIsSubmitDisabled(is);
  }, [

  ]); // Dependencies array

  useEffect(() => {
    // Function to fetch credentials


    // fetchData();
    trackDirtiness(); // Track dirtiness on initial render
    const is = !isFormValid();
    setIsSubmitDisabled(is);
  }, [
    scanName,
    customPort,
    customPortNumber,
    assetIp,
    selectedVendor,
    selectedCategory,
    selectedCredential,
    username,
    passwordType,
    password,
    execPassword,
    execPasswordText,
    autoAssign,
    isScheduled,
    saveCredential,
    selectedFrequency,
    selectedDay,
    selectedHour,
    selectedMinute,
    selectedAmPm,
    selectedDate,
    credName,
    files,
    isSwitchOn,
    privateKeyFile,
    privateKeyValidationMessage
  ]);

  const isFormValid = () => {
    const selectedFrequencyObj = scheduleOptions?.frequency?.find(
      (f: any) => f.id === selectedFrequency
    );
    return (

      (isSwitchOn
        ? files.length > 0 // If isSwitchOn is true, ensure files.length > 0
        : assetIp.trim() !== "" &&
        (ipRegex.test(assetIp) || urlRegex.test(assetIp)) &&
        (selectedVendor === null || selectedCategory !== null)) &&
      selectedCredential !== null &&
      (component !== "api" // Skip the credential validation if component is 'api'
        ? selectedCredential !== "Create New Credential" ||
        (username.trim() !== "" &&
          credName.trim() !== "" &&
          ((passwordType !== "password") ||
            (component === "winRM" && passwordType === "password") || // Skip exec/auto checks for winRM
            ((execPassword && execPasswordText.trim() !== "") || autoAssign)) &&
          (passwordType === "none" ||
            (passwordType === "password" && password.trim() !== "") ||
            (passwordType === "private_key" &&
              privateKeyFile !== null)))
        : selectedCredential !== "Create New Credential" ||
        password.trim() !== "") &&
      (!isScheduled ||
        (isScheduled &&
          selectedFrequency !== null &&
          // Scenario 1: Weekly -> On Day & Time are mandatory
          ((selectedFrequencyObj?.name === "Weekly" &&
            selectedDay !== null &&
            selectedHour !== "" &&
            selectedMinute !== "" &&
            selectedAmPm !== "") ||
            // Scenario 2: Hourly -> Time is mandatory
            (selectedFrequencyObj?.name === "Hourly" &&
              hourlyInterval !== "" &&
              hourlyMinute !== "" &&
              selectedAmPm !== "") ||
            // Scenario 3: Other frequencies -> Date & Time are mandatory
            (selectedFrequencyObj?.name !== "Weekly" &&
              selectedFrequencyObj?.name !== "Hourly" &&
              selectedDate !== null &&
              selectedHour !== "" &&
              selectedMinute !== "" &&
              selectedAmPm !== ""))))
    );
  };

  // Validate input for scan name (scanName is optional)
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setScanName(value);
    setError(""); // No error unless the field is required and empty
  };

  // Handle the radio button change for custom_port
  const handleCustomPortChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newCustomPort = event.target.value === "true";
    setCustomPort(newCustomPort);
    setCustomPortNumber(""); // Reset customPortNumber when changing customPort value
    setCustomPortError(""); // Reset error when changing customPort
  };

  // Handle the custom_port_number input change
  const handleCustomPortNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setCustomPortNumber(value);
      setCustomPortError(""); // Clear error on valid input
    } else {
      setCustomPortError("Only numbers are allowed");
    }
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    setSelectedCredential(value);
    //setDirty(true); // Mark as dirty when selection is made
    setError(""); // Clear error when value is selected
    //onCredentialChange(value); // Call parent function to handle the change
    if (value !== "Create New Credential") {
      setPrivateKeyFile(null);
      setPrivateKeyValidationMessage("");
      setPassword("");
      setPasswordError("");
    }
  };

  const handleUsernameChange = (event: any) => {
    setUsername(event.target.value);
  };
  const handleCredName = (event: any) => {
    setCredName(event.target.value);
  };
  const handlePasswordTypeChange = (event: any) => {
    const value = event.target.value;
    setPasswordType(value);
    setPassword("");
    setPasswordError("");
    setPrivateKeyFile(null);
    setPrivateKeyValidationMessage("");

    const matchingCredentialType =
      credentialsTypes.find((type) => type.code === (component === "winRM" ? "windows" : component)) || credentialsTypes[0];

    if (matchingCredentialType && matchingCredentialType.password_type) {
      const type = matchingCredentialType.password_type.find(
        (type: { code: string }) => type.code === value
      );
      if (type) {
        setCredentialTypeId(type.id);
      }
    }
  };

  const handleExecPasswordToggle = (event: any) => {
    setExecPassword(event.target.checked);
    if (event.target.checked) {
      setAutoAssign(false); // Disable Auto Assign when Exec Password is selected
    }
  };

  const handleAutoAssignToggle = (event: any) => {
    setAutoAssign(event.target.checked);
    if (event.target.checked) {
      setExecPassword(false); // Disable Exec Password when Auto Assign is selected
    }
  };

  const handlePasswordChange = (event: any) => {
    setPassword(event.target.value);
  };

  const handleExecPasswordText = (event: any) => {
    setExecPasswordText(event.target.value);
  };

  const validate = () => {
    if (selectedCredential === "") {
      setError("Credential is required.");
      return false;
    }
    return true;
  };
  const handleVendorChange = (event: any) => {
    const value = event.target.value;
    setSelectedVendor(value === "" ? null : value);

    setVendorError(""); // Clear error if a valid selection is made
    // Find the selected vendor and update the categories
    if (value) {
      const vendor = vendorList.find((v) => v.id === value);
      setVendorName(vendorList.find((v) => v.id === value)?.name || "");
      if (vendor) {
        setCategories(vendor.categories);
        setSelectedCategory(null); // Reset category when vendor changes
      }
    } else {
      // If no vendor is selected, clear categories
      setCategories([]);
      setSelectedCategory(null);
    }
  };

  const handleCategoryChange = (event: any) => {
    const value = event.target.value;
    setSelectedCategory(value);
    setIsCategoryDirty(value !== null);
    setCategoryError(""); // Clear error if a valid selection is made
  };

  // Handle the Asset IP input change
  const handleAssetIpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setAssetIp(value);

    // Validate if the value is either a valid IP or a valid URL
    if (value.trim()) {
      if (!ipRegex.test(value) && !urlRegex.test(value)) {
        setAssetIpError("Invalid IP address or URL format");
      } else {
        setAssetIpError(""); // Clear error if either IP or URL is valid
      }
    } else {
      setAssetIpError(""); // Clear error if input is empty
    }
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent, buttonType: 'scan' | 'schedule') => {
    e.preventDefault();
    setProcessingButton(buttonType);
    setIsLoading(true); // <-- set loading true here

    let ssh_data: any = {};
    if (component === "winRM") {
      const user_id: never[] = [];
      const role_id: never[] = [];
      ssh_data.user_id = user_id;
      ssh_data.role_id = role_id;
      ssh_data.scan_type = "winRM";
    } else if (component === "ssh") {
      const user_id: never[] = [];
      const role_id: never[] = [];
      ssh_data.user_id = user_id;
      ssh_data.role_id = role_id;
      ssh_data.scan_type = "ssh";
    } else {
      ssh_data.scan_type = "api";
    }
    if (scanName.trim() != "") {
      ssh_data.scanname = scanName;
    }
    ssh_data.component = component;
    // if(isSwitchOn && files.length>0){
    //   ssh_data.resumes = files;
    // }
    if (!isSwitchOn) {
      ssh_data.custom_port = customPort;
      ssh_data.host = doEncryptLogin(assetIp);
      ssh_data.vendor = selectedVendor;
      ssh_data.category_id = selectedCategory;
      if (customPort) {
        ssh_data.custom_port_number = customPortNumber;
      }

    } else if (isSwitchOn && selectedVendor) {
      ssh_data.vendor_key = selectedVendor;
    }



    if (selectedCredential === "Create New Credential") {
      ssh_data.selectedCredential = "Create New Credential";
      ssh_data.new_cred = true;
      ssh_data.save = isScheduled ? true : saveCredential;
      ssh_data.global_cred = false;
      ssh_data.credentialsTypes = credentialsTypes;
      ssh_data.cred_name = credName;
      console.log(vendorname, 'vendorname');
      if (component === "api" && passwordType == "password") {
        ssh_data.username = doEncryptLogin(username);

      }

      if (component != "api") {
        ssh_data.encrypt = true;
        delete ssh_data.selectedCredential;
        delete ssh_data.credentialsTypes;
        ssh_data.loginParameter = passwordType;
        if (passwordType === "private_key") {
          if (privateKeyFile) {
            ssh_data.private_key_name = privateKeyFile.name;
            ssh_data.private_key = privateKeyFile;
          }
        } else if (passwordType === "password") {
          ssh_data.password = doEncryptLogin(password);
        }
        ssh_data.username = doEncryptLogin(username);
        ssh_data.auto_assign = autoAssign;
        ssh_data.exec_password = execPassword;

        let targetCredentialType = credentialsTypes.length > 0 ? credentialsTypes[0] : null;

        if (component === "winRM") {

          const winRMType = credentialsTypes.find((t: any) => t.code === "windows");
          if (winRMType) {
            targetCredentialType = winRMType;
          }
        }

        if (targetCredentialType && targetCredentialType.password_type) {
          const type: any = targetCredentialType.password_type.find(
            (type: { code: string }) => type.code === passwordType
          );
          if (type) {
            ssh_data.credential_type_id = type.id;
          }
        }

        ssh_data.description = "";
        if (execPassword) {
          ssh_data.enable_password = doEncryptLogin(execPasswordText);
        }
      } else {
        ssh_data.loginParameter = passwordType;
        ssh_data.password = password;
      }
    } else {
      ssh_data.cred_id = selectedCredential;
      ssh_data.new_cred = false;
      ssh_data.loginParameter = passwordType;
    }

    //

    // } else {
    //     ssh_data.selectedCredential=""
    //
    // }

    if (isScheduled) {
      ssh_data.frequency_id = selectedFrequency;
      
      const selectedFrequencyObj = scheduleOptions?.frequency?.find(
        (f: any) => f.id === selectedFrequency
      );

      if (selectedDate && selectedFrequencyObj?.name !== "Hourly") {
        ssh_data.date = date;
      }
      if (selectedDay) {
        ssh_data.day = selectedDay;
      }
      // Set time based on frequency type
      if (selectedFrequencyObj?.name === "Hourly") {
        ssh_data.time = `${hourlyInterval}:${hourlyMinute} ${selectedAmPm}`;
      } else {
        ssh_data.time = selectedTime;
      }
      ssh_data = utcObj(ssh_data);

      if (selectedFrequencyObj?.name === "Hourly") {
        delete ssh_data.date; // Ensure date is not sent for hourly frequency
      }
    }

    if (onCallback) {

      await onCallback(ssh_data, isSwitchOn, files);
      setProcessingButton(null);

      setIsLoading(false); // <-- set loading false after done
    }

  };

  const assetCount = async () => {
    console.log("assetCount called");
    dispatch(resetUserTypeFlags());


    const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
    let parsed = null;
    if (res.status === 200) {
      dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
      dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
      dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
      const isNewUser = res?.data?.data || false;
      parsed = res?.data?.data || false;
      if (parsed.device_count == 0 && parsed.cloud_count == 0) {
        dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
        //dispatch(setIsOnlyCloudUser({ is: true }));

      }
      else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
        dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
      } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
        dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
      } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
        dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true }));
      }
    }
  }

  const handleSaveCredential = (event: any) => {
    if (!isScheduled) {
      setSaveCredential(event.target.checked);
    }
    // setSaveCredential(event.target.checked);
  };

  const handleScheduleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsScheduled(event.target.checked);
    if (!event.target.checked) {
      setSelectedFrequency(null);
      setSelectedDate(null);
      setSelectedDay(null);
      setSelectedTime(null);
    } else {
      setSaveCredential(true);
    }
    //setIsScanNowDisabled(event.target.checked);
    setIsScheduleScanDisabled(!event.target.checked);
    onDirty(event.target.checked);
  };

  // Handle Frequency Change
  const handleFrequencyChange = (event: any) => {
    const value = event.target.value;
    setSelectedFrequency(value);
    // Reset date and day when frequency changes
    setSelectedDate(null);
    setSelectedDay(null);
    setSelectedTime(null);
    setSelectedHour("");
    setSelectedMinute("");
    setSelectedAmPm("");
    setHourlyInterval("");
    setHourlyMinute("");
  };


  const handleDateChange = (newDate: dayjs.Dayjs | null) => {
    console.log(newDate?.year());

    // Convert Dayjs object to JS Date
    //const dateAsJS = newDate.toDate();
    setSelectedDate(newDate);
    const day = newDate?.date(); // Get the day of the month
    const month = newDate ? newDate.month() + 1 : 0; // Get the month (1-based, not 0-based)
    const year = newDate?.year(); // Get the year and make it negative

    const formatted = `${day}-${month}-${year}`;
    setDate(formatted);

    const today = dayjs().startOf("day"); // Get today's date without time
    const isToday = newDate ? newDate.isSame(today, "day") : false; // Compare only the date, not the time

    if (isToday) {
      // If the selected date is today's date, set time to current time + 5 minutes
      const currentTime = new Date();
      currentTime.setMinutes(currentTime.getMinutes() + 5);

      const hour = currentTime.getHours();
      const minute = currentTime.getMinutes();
      const period = hour < 12 ? "AM" : "PM";
      const formattedHour = (hour % 12 || 12).toString();
      const formattedMinute = minute.toString().padStart(2, '0');

      setSelectedHour(formattedHour);
      setSelectedMinute(formattedMinute);
      setSelectedAmPm(period);
      setSelectedTime(`${formattedHour}:${formattedMinute} ${period}`);
    } else {
      // If it's not today's date, set default time to 12:00 PM
      setSelectedHour("12");
      setSelectedMinute("00");
      setSelectedAmPm("PM");
      setSelectedTime("12:00 PM");
    }
  };

  // Handle Day Change (Only for weekly frequency)
  const handleDayChange = (event: any) => {
    setSelectedDay(event.target.value);
  };


  // Handle Hour Change
  const handleHourChange = (event: any) => {
    setSelectedHour(event.target.value);
    // Update the combined time string
    const timeString = `${event.target.value}:${selectedMinute} ${selectedAmPm}`;
    setSelectedTime(timeString);
  };

  // Handle Minute Change
  const handleMinuteChange = (event: any) => {
    setSelectedMinute(event.target.value);
    // Update the combined time string
    const timeString = `${selectedHour}:${event.target.value} ${selectedAmPm}`;
    setSelectedTime(timeString);
  };

  // Handle AM/PM Change
  const handleAmPmChange = (event: any) => {
    setSelectedAmPm(event.target.value);
    // Update the combined time string
    const timeString = `${selectedHour}:${selectedMinute} ${event.target.value}`;
    setSelectedTime(timeString);
  };

  // Handle Hourly Interval Change
  const handleHourlyIntervalChange = (event: any) => {
    setHourlyInterval(event.target.value);
  };

  // Handle Hourly Minute Change
  const handleHourlyMinuteChange = (event: any) => {
    setHourlyMinute(event.target.value);
  };

  const isWeekly = () => {
    return (
      scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency)
        ?.name === "Weekly"
    );
  };

  const isHourly = () => {
    return (
      scheduleOptions?.frequency?.find((f: any) => f.id === selectedFrequency)
        ?.name === "Hourly"
    );
  };

  const isOtherFrequency = () => {
    return selectedFrequency && !isWeekly() && !isHourly();
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <div style={{ paddingRight: 20, paddingLeft: 15 }}>
      <Box
        component="form"
        onSubmit={(e) => handleSubmit(e, 'scan')}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Typography
          variant="h6"
          sx={{ fontSize: "15px", fontWeight: 500, lineHeight: "23px", mb: 2 }}
        >
          {banner}
        </Typography>
        <div>
          <TextField
            label="Scan Name (Optional)"
            variant="outlined"
            fullWidth
            value={scanName}
            onChange={handleInputChange}
            error={!!error}
            helperText={error || ""}
            sx={{ marginBottom: 3 }}
          />
        </div>

        <div>
          {component !== "api" || component !== "winRM" && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "16px",
                  color: isDarkMode ? "#BDBDDA" : "#1e2036",
                }}
              >
                Single Asset
              </Typography>

              <IOSSwitch
                offColor="#3a2ada!important"
                onColor="#3a2ada!important"
                width={48}
                thumbSize={18}
                checked={isSwitchOn}
                onChange={handleSwitchChange}
              />

              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "16px",
                  color: isDarkMode ? "#BDBDDA" : "#1e2036",
                }}
              >
                Multiple Asset
              </Typography>
            </div>
          )}
        </div>

        {isSwitchOn && (
          <>
            <div>
              {/* This content is shown when the switch is ON */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 10,
                }}
              >
                <Typography
                  style={{ fontWeight: 400, fontSize: "14px", marginBottom: 10 }}
                >
                  Upload or Browse files
                </Typography>
                <Link sx={{ fontWeight: "bold" }} onClick={fetchFileData}>
                  Download Sample file
                </Link>
              </div>
              {files.length == 0 && (
                <div
                  style={{
                    border: "1px dashed blue",
                    padding: "20px",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 5,
                    transition: "border-color 0.3s ease-in-out",
                    backgroundColor: "#DFDEEC4D",
                    marginBottom: 30,
                  }}
                >
                  <Button
                    component="label"
                    variant="text"
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "inherit",
                      },
                      color: "inherit",
                    }}
                  >
                    <Box textAlign="center">
                      <img src={Upload_img} alt="" style={{ marginBottom: 10 }} />
                      <Typography
                        className="upload-text"
                        sx={{ color: "inherit", fontWeight: "bold", mb: 1 }}
                      >
                        Upload files
                      </Typography>
                      <Typography
                        className="upload-text"
                        sx={{
                          color: "#808080 !important",
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        or
                      </Typography>
                      <Typography
                        className="upload-text"
                        sx={{
                          color: "#696595 !important",
                          fontWeight: 500,
                          mb: 2,
                        }}
                      >
                        Browse
                      </Typography>
                      <Typography
                        className="upload-text"
                        sx={{
                          color: "#696595 !important",
                          fontWeight: 500,
                          mb: 2,
                        }}
                      >
                        (Supported file formats - CSV/XSL)
                      </Typography>
                    </Box>

                    <VisuallyHiddenInput
                      type="file"
                      onChange={handleFileChange}
                      multiple
                    />
                  </Button>
                </div>
              )}


              {/* Show uploaded files if there are any */}
              {files.length > 0 && (
                <div className="uploaded-files-container">
                  <Typography sx={{ color: isDarkMode ? "#FFFFFF" : "#1e2036", fontSize: "14px", fontWeight: 500, mb: 1 }}>Uploaded files</Typography>
                  <div className="uploaded-files-section">
                    <Typography className="uploaded-files" sx={{ color: isDarkMode ? "#FFFFFF" : "#1e2036", fontSize: "12px", fontWeight: 700 }}>
                      {files.length} {files.length === 1 ? "File" : "Files"} uploaded
                    </Typography>
                    <div className="scroll uploaded-list">
                      <ul>
                        {files.map((file, index) => (
                          <li key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span title={file.name} style={{ color: isDarkMode ? "#FFFFFF" : "#1e2036" }}>{file.name}</span>

                            <IconButton
                              onClick={() => deleteFile(index)}
                              color="secondary"
                              size="small"
                              sx={{ marginLeft: "10px", color: isDarkMode ? "#FFFFFF" : undefined }}
                            >
                              <CloseIcon />
                            </IconButton>

                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {!isSwitchOn && (
          <div>



            <FormControl component="fieldset" sx={{ mb: 1 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Custom Port
              </Typography>
              <RadioGroup
                row
                value={customPort.toString()}
                onChange={handleCustomPortChange}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="True"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="False"
                />
              </RadioGroup>
            </FormControl>


            <TextField
              label="Custom Port Number"
              variant="outlined"
              fullWidth
              value={customPortNumber}
              onChange={handleCustomPortNumberChange}
              error={!!customPortError}
              helperText={customPortError || ""}
              required // Make required when customPort is true
              sx={{ marginBottom: 3 }}
              disabled={!customPort}
            />

            <TextField
              label="Asset IP / URL"
              variant="outlined"
              fullWidth
              value={assetIp}
              onChange={handleAssetIpChange}
              error={!!assetIpError}
              helperText={assetIpError || ""}
              required
              sx={{ marginBottom: 3, borderColor: "black" }}
            />

            <FormControl
              fullWidth
              error={!!vendorError}
              sx={{ marginBottom: 2 }}
            >
              <InputLabel>Vendor (Optional)</InputLabel>
              <Select
                value={selectedVendor}
                onChange={handleVendorChange}
                label="Vendor (Optional)"
                name="vendor"
                sx={{
                  borderRadius: 2,
                  height: "50px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    //borderColor: "black", 
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black",
                  },
                }}
              >
                <MenuItem value=""></MenuItem>

                {vendorList.map((vendor) => {

                  if (
                    component === "api" && (component != "winRM" && component != "ssh") &&
                    ((vendor.name.toLowerCase() === "paloalto" || vendor.name.toLowerCase() === "Palo Alto" || vendor.name.toLowerCase() === "palo alto")
                      || (vendor.name.toLowerCase() === "fortinet" || vendor.name.toLowerCase() === "forti" || vendor.name.toLowerCase() === "fortigate")
                      || (vendor.name.toLowerCase() === "sophos" || vendor.name.toLowerCase() === "Sophos" || vendor.name.toLowerCase() === "SOPHOS")
                    )
                  ) {
                    return (
                      <MenuItem key={vendor.name} value={vendor.id}>
                        {vendor.name}
                      </MenuItem>
                    );
                  }


                  if (component == "ssh" && (component != "api" || component != "winRM") && (vendor.name.toLowerCase() != "microsoft")) {
                    return (
                      <MenuItem key={vendor.name} value={vendor.id}>
                        {vendor.name}
                      </MenuItem>
                    );
                  }


                  if (component == "winRM" && (component != "api" || component != "ssh") && (vendor.name.toLowerCase() == "microsoft")) {
                    return (
                      <MenuItem key={vendor.name} value={vendor.id}>
                        {vendor.name}
                      </MenuItem>
                    );
                  }

                  // If conditions don't match, return null (this shouldn't happen in this logic)
                  return null;
                })}
              </Select>
              <FormHelperText>{vendorError}</FormHelperText>
            </FormControl>
            {selectedVendor !== null && (
              <FormControl
                fullWidth
                error={!!categoryError}
                required
                sx={{ marginBottom: 2 }}
              >
                <InputLabel>Category</InputLabel>
                <Select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  label="Category"
                  name="category"
                  sx={{
                    borderRadius: 2,
                    height: "50px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      //borderColor: "black", // Black border like TextField
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black",
                    },
                  }}
                >
                  {categories.map((category) => (
                    <MenuItem key={category.name} value={category.id}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{categoryError}</FormHelperText>
              </FormControl>
            )}


          </div>
        )}
        <div>
          <FormControl
            fullWidth
            variant="outlined"
            error={!!error}
            required
            sx={{ marginBottom: 3 }}
          >
            <InputLabel>Select Credential</InputLabel>
            <Select
              value={selectedCredential}
              onChange={handleChange}
              label="Select Credential"
              onBlur={validate} // Optionally validate on blur
              sx={{
                borderRadius: 2,
                height: "50px",
                "& .MuiOutlinedInput-notchedOutline": {
                  //borderColor: "black", // Black border like TextField
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  //borderColor: "black",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "black",
                },
              }}
            >
              {/* "Create New Credential" option */}
              <MenuItem value="Create New Credential">
                <SvgIcon sx={{ mr: 1, mt: .60, verticalAlign: 'middle', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                  <path
                    d="M9.00012 17.303C13.5857 17.303 17.303 13.5857 17.303 9.00012C17.303 4.41458 13.5857 0.697266 9.00012 0.697266C4.41458 0.697266 0.697266 4.41458 0.697266 9.00012C0.697266 13.5857 4.41458 17.303 9.00012 17.303Z"
                    fill="#3A2ADA"
                  />
                  <path
                    d="M9 18C4.0378 18 0 13.9629 0 9C0 4.0378 4.0378 0 9 0C13.9629 0 18 4.0378 18 9C18 13.9629 13.9629 18 9 18ZM9 1.39426C4.80604 1.39426 1.39426 4.80604 1.39426 9C1.39426 13.194 4.80604 16.6057 9 16.6057C13.194 16.6057 16.6057 13.1933 16.6057 9C16.6057 4.80604 13.194 1.39426 9 1.39426Z"
                    fill="#3A2ADA"
                  />
                  <path
                    d="M9.00037 13.1205C8.61555 13.1205 8.30322 12.8089 8.30322 12.4234V5.45203C8.30322 5.06721 8.61555 4.75488 9.00037 4.75488C9.38519 4.75488 9.69752 5.06721 9.69752 5.45203V12.4234C9.69752 12.8089 9.38519 13.1205 9.00037 13.1205Z"
                    fill="white"
                  />
                  <path
                    d="M12.4859 9.63453H5.51453C5.12971 9.63453 4.81738 9.3222 4.81738 8.93738C4.81738 8.55256 5.12971 8.24023 5.51453 8.24023H12.4859C12.8714 8.24023 13.183 8.55256 13.183 8.93738C13.183 9.3222 12.8714 9.63453 12.4859 9.63453Z"
                    fill="white"
                  />
                </SvgIcon>
                Create New Credential
              </MenuItem>

              {/* Option for each credential in credentialsList */}
              {credentialsList.length > 0 ? (
                credentialsList.map((cred: any) => (
                  <MenuItem key={cred.id} value={cred.id}>
                    {cred.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Credentials Available</MenuItem>
              )}
            </Select>
            <FormHelperText>{error}</FormHelperText>
            {/* {loading && <CircularProgress size={24} sx={{ position: 'absolute', right: 16, top: 16 }} />} */}
          </FormControl>


          <CredentialForm
            selectedCredential={selectedCredential}
            username={username}
            usernameError={usernameError}
            handleUsernameChange={handleUsernameChange}
            passwordType={passwordType}
            passwordTypeError={passwordTypeError}
            handlePasswordTypeChange={handlePasswordTypeChange}
            password={password}
            passwordError={passwordError}
            handlePasswordChange={handlePasswordChange}
            execPassword={execPassword}
            handleExecPasswordToggle={handleExecPasswordToggle}
            autoAssign={autoAssign}
            handleAutoAssignToggle={handleAutoAssignToggle}
            execPasswordText={execPasswordText}
            handleExecPasswordText={handleExecPasswordText}
            saveCredential={saveCredential}
            handleSaveCredential={handleSaveCredential}
            isScheduled={isScheduled}
            credName={credName}
            credNameError={credNameError}
            handleCredName={handleCredName}
            component={component}
            selectedVendor={selectedVendor}
            vendorName={vendorname}
            onPrivateKeyUpload={handlePrivateKeyUpload}
            privateKeyValidationMessage={privateKeyValidationMessage}
          />


          <Divider variant="fullWidth" />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={isScheduled}
                  onChange={handleScheduleChange}
                />
              }
              label="Schedule for scan"
              sx={{
                justifyContent: 'flex-start',
                width: '100%',
                mb: 2,
                '.MuiFormControlLabel-label': {
                  fontSize: '14px',
                  color: '#696595!important',
                  lineHeight: '24px',
                  fontWeight: 500,
                  textAlign: 'left',
                },
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#696595",
                fontSize: "12px",
                marginTop: "-4px",
                textAlign: 'left',
                mb: 2,
              }}
            >
              Your credentials will be saved for future use

            </Typography>
          </Box>

          <ScheduleForm
            isScheduled={isScheduled}
            selectedFrequency={selectedFrequency}
            handleFrequencyChange={handleFrequencyChange}
            scheduleOptions={scheduleOptions}
            isOtherFrequency={isOtherFrequency}
            selectedDate={selectedDate}
            handleDateChange={handleDateChange}
            isWeekly={isWeekly}
            isHourly={isHourly}
            selectedDay={selectedDay}
            handleDayChange={handleDayChange}
            selectedHour={selectedHour}
            selectedMinute={selectedMinute}
            selectedAmPm={selectedAmPm}
            handleHourChange={handleHourChange}
            handleMinuteChange={handleMinuteChange}
            handleAmPmChange={handleAmPmChange}
            hourlyInterval={hourlyInterval}
            hourlyMinute={hourlyMinute}
            handleHourlyIntervalChange={handleHourlyIntervalChange}
            handleHourlyMinuteChange={handleHourlyMinuteChange}
          />

        </div>


        <Box display="flex" gap={2} justifyContent="center" mt={2} mb={4}>
          {/* Scan Now Button */}
          <Button
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isSubmitDisabled || isScheduled || isLoading}
            onClick={(e) => handleSubmit(e, 'scan')}
          >
            {isLoading && processingButton === 'scan' ? "Processing..." : "Scan Now"}
          </Button>

          {/* Schedule Scan Button */}
          <Button
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isSubmitDisabled || !isScheduled || isLoading}
            onClick={(e) => handleSubmit(e, 'schedule')}
          >
            {isLoading && processingButton === 'schedule' ? "Processing..." : "Schedule Scan"}
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default ReusableSSHAPI;